export const SHOW_SIDEBAR_PAGE = 'SHOW_SIDEBAR_PAGE';
export const HIDE_SIDEBAR_PAGE = 'HIDE_SIDEBAR_PAGE';

export const UPDATE_SIDEBAR_STATE = 'UPDATE_SIDEBAR_STATE';

export const ADD_MEMBER_SELECTED_PROJECT = 'ADD_MEMBER_SELECTED_PROJECT';
